// extracted by mini-css-extract-plugin
module.exports = {"modal_subtitle":"modal-subtitle_modal_subtitle__rV_Wi"};